export default __webpack_public_path__ + "static/media/man-developer.a6e9fb6b.png";